var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 5c-.56 0-1.014.454-1.014 1.014v7.347H7.264a1.014 1.014 0 0 0 0 2.027h7.347v7.348a1.013 1.013 0 1 0 2.027 0v-7.348h7.348a1.013 1.013 0 1 0 0-2.027h-7.348V6.014c0-.56-.453-1.014-1.013-1.014Z"
  })));
};
export default SvgPlus;